<form novalidate autocomplete="off">
  <div id="payment-element" class="m-3">
    <!-- Mount the Payment Element here -->
  </div>

  <div class="input-container submit-input m-3">
    <button class="btn" id="submit" (click)="handleSubmit($event)">Pay {{totalPrice}}</button>
  </div>
</form>
